import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VideoExercise', 'v1');
export default exerciseTypeVersionAdapter;